window.addEventListener('DOMContentLoaded', () => {

    let blockItems = document.querySelectorAll('.timeline-block--item');

    if (blockItems.length) {

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.remove('hidden');
                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.5
        });

        blockItems.forEach(block => observer.observe(block));

    }


    // Observer for progress bar: adds a class when block enters view

    const timelineBlocks = document.querySelectorAll('.timeline-block');

    if( timelineBlocks.length ){

        observeTimelineBlocks(timelineBlocks);

    }

    function observeTimelineBlocks(blocks){

        const observer = new IntersectionObserver( entries => {
            entries.forEach( entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('in-viewport');
                    updateProgress();
                } else {
                    entry.target.classList.remove('in-viewport');
                }
            });
        }, { threshold: 0 });

        blocks.forEach( block => observer.observe(block) );

        window.addEventListener('scroll', onScroll);
        window.addEventListener('resize', updateProgress);

    }


    function updateProgress() {

        const viewportHeight = window.innerHeight;
        let allDone = true;

        document.querySelectorAll('.timeline-block').forEach( block => {

            if (block.dataset.done === 'true') return;

            if (!block.classList.contains('in-viewport')) {
                allDone = false;
                return;
            }
            
            const rect          = block.getBoundingClientRect();
            const blockHeight   = rect.height;

            let visible     = viewportHeight - rect.top;
            visible         = Math.max(0, Math.min(visible, blockHeight));

            let progress    = (visible / blockHeight) * 100; // calc % block visible
            progress        = Math.min(progress, 100); // Max 100% height

            block.style.setProperty('--timeline-progress-height', `${progress}%`);

            if (progress >= 100) {
                block.dataset.done = 'true';
                block.classList.add('completed');
            } else {
                allDone = false;
            }
        });

        // stop listening when block is fully in viewport
        if (allDone) {
            window.removeEventListener('scroll', onScroll);
        }
    }

    let ticking = false;

    function onScroll() {
        if (!ticking) {
            requestAnimationFrame(() => {
                updateProgress();
                ticking = false;
            });
            ticking = true;
        }
    }

});


